import { atarrayaApi } from '../../api-common'

export const state = {
  deals: [],
  stages: [],
  playgrounds: [],
  playground: [],
  invoices: [],
  products: [],
  invoicesBd: []
}

export const getters = {
  deals: (state) => state.deals,
  stages: (state) => state.stages,
  playgrounds: (state) => state.playgrounds,
  playground: (state) => state.playground,
  invoices: (state) => state.invoices,
  invoicesBd: (state) => state.invoicesBd
}

export const mutations = {
  LOAD_SIMPLE_DEALS(state, newValue) {
    state.deals = newValue
  },

  LOAD_SIMPLE_STAGES(state, newValue) {
    state.stages = newValue
  },

  LOAD_PLAYGROUNDS(state, newValue) {
    state.playgrounds = newValue
  },

  LOAD_PLAYGROUND(state, newValue) {
    state.playground = newValue
  },

  LOAD_INVOICES(state, newValue) {
    state.invoices = newValue
  },

  UPDATE_INVOICE_PRODUCT(state, newValue) {
    state.products.push(newValue)
  },

  DELETE_INVOICE_PRODUCT(state, data) {
    const { category, presentation, commercialSize } = data

    const order = state.products.find(
      (p) =>
        p.category === category &&
        p.presentation === presentation &&
        p.commercialSize === commercialSize
    )

    if (order) {
      return
    }
  },

  LOAD_INVOICES_BD(state, newValue) {
    state.invoicesBd = newValue
  },

  ADD_PLAYGROUND(state, newPlayground) {
    state.playgrounds.push(newPlayground)
  },

  // UPDATE_PLAYGROUND (state, updatedPlayground) {
  //   const index = state.playgrounds.findIndex(
  //     p => p.id === updatedPlayground.id
  //   );
  //   if (index !== -1) {
  //     state.playgrounds.splice(index, 1, updatedPlayground);
  //   }
  // }
}

export const actions = {
  async getDeals({ commit }, { farmId, stagesIds }) {
    const stagesParams = stagesIds
      .map((stageId) => `&stageId=${stageId}`)
      .join('')

    const response = await atarrayaApi.get(
      `business/hubspot/deals?farmId=${farmId}${stagesParams}`
    )
    commit('LOAD_SIMPLE_DEALS', response.data.data)
    return response.data.data
  },

  async getStages({ commit }) {
    const response = await atarrayaApi.get(`business/hubspot/stages`)
    commit('LOAD_SIMPLE_STAGES', response.data.data)
    return response.data.data
  },

  async savePlayground({ commit }, data) {
    const response = await atarrayaApi.post(
      `business/playground/projections`,
      data
    )
    commit('ADD_PLAYGROUND', response.data.data)
    return response.data.data
  },

  async getPlaygrounds({ commit }, farmId) {
    const response = await atarrayaApi.get(
      `business/playground/projections?farm=${farmId}`
    )
    commit('LOAD_PLAYGROUNDS', response.data.data)
    return response.data.data
  },

  async getPlaygroundById({ commit }, playgorundId) {
    const response = await atarrayaApi.get(
      `business/playground/projections/${playgorundId}`
    )
    commit('LOAD_PLAYGROUND', response.data.data)
    return response.data.data
  },

  async getHubspotInvoices({ commit }, data) {
    const response = await atarrayaApi.get('business/hubspot/invoices', {
      params: {
        farmId: data.farmId,
        startAt: data.startAt,
        endAt: data.endAt,
        status: data.status
      }
    })
    commit('LOAD_INVOICES', response.data.data)
    return response.data.data
  },

  async editInvoiceProduct({ commit }, data) {
    await atarrayaApi.patch(`business/invoices`, data)
    commit('UPDATE_INVOICE_PRODUCT', data)
  },

  async deleteInvoiceOrder({ commit }, data) {
    await atarrayaApi.delete(`business/invoices/${data.invoiceId}`, { data })
    commit('DELETE_INVOICE_PRODUCT', data)
  },

  async savePlaygroundAsDefault ({ commit }, id) {
    const response = await atarrayaApi.patch(
      `business/playground/projections/${id}/active`
    );
    commit('LOAD_PLAYGROUND', response.data.data);
    // commit('UPDATE_PLAYGROUND', response.data.data);
    return response.data.data;

  }

}
